import React from 'react';
import LazyImage from '../lazy-image';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import parseStoryblokLink from '../../utils/parseStoryblokLink';
import { Link } from 'gatsby';

const LogoGridItemContainer = styled.div<{
  $theme?: 'white' | 'grey';
}>`
  width: 100%;
  position: relative;
  background: ${({ $theme }) => ($theme === 'white' ? '#F8F8F8' : '#fff')};
  overflow: hidden;
  border-radius: var(--Radius-Radius-3, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 8px 24px 8px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 20px;
  aspect-ratio: 129 / 196;
  gap: 20px;
`;

const LogoGridItemImage = styled.span<{
  $theme?: 'white' | 'grey';
}>`
  aspect-ratio: 129 / 196;
  overflow: hidden;
  position: relative;
  user-select: none;
  background: ${({ $theme }) => ($theme === 'white' ? '#F8F8F8' : '#fff')};
  padding: 40px;
  @media (max-width: 870px) {
    padding: 20px;
  }
`;

const ItemTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
`;

const ItemTitle = styled.h3`
  text-decoration: none;
  color: #161616;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.36px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: balance;
  user-select: none;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

const ItemButton = styled(Link)`
  text-decoration: none;
  color: #813dff;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
  user-select: none;
`;

export default function LogoGridItem({
  asset,
  title,
  ctaLink,
  ctaText,
  theme = 'white'
}: {
  asset: any;
  title: string;
  ctaLink: any;
  ctaText: string;
  theme?: 'white' | 'grey';
}) {
  return (
    <LogoGridItemContainer $theme={theme}>
      <LogoGridItemImage $theme={theme}>
        <LazyImage
          fluid={getFluidGatsbyImage(asset)}
          width="100%"
          height="100%"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            backgroundColor: 'transparent'
          }}
          imgStyle={{
            objectFit: 'contain',
            backgroundColor: 'transparent',
            mixBlendMode: 'darken',
            opacity: 0.8
          }}
        />
      </LogoGridItemImage>
      <ItemTitleContainer>
        <ItemTitle>{title}</ItemTitle>
        <ItemButton to={parseStoryblokLink(ctaLink)}>{ctaText}</ItemButton>
      </ItemTitleContainer>
    </LogoGridItemContainer>
  );
}
